import { useRouter } from 'next/router';

import { isBrowser } from './is-browser';

export function useBack(defaultRoute: string = '/') {
  const { back, push } = useRouter();

  const onBack = () => {
    if (isBrowser()) {
      const hasHistory = window.history.length > 1;
      const { referrer } = document;
      const fromSameOrigin = referrer && new URL(referrer).origin === window.location.origin;
      const referrerPathname = fromSameOrigin ? new URL(referrer).pathname : null;

      const isNot404 = referrerPathname !== '/404';

      if (hasHistory && fromSameOrigin && isNot404) {
        back();
      } else {
        push(defaultRoute);
      }
    } else {
      push(defaultRoute);
    }
  };

  return onBack;
}
